import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1"
      data-product-shop="true"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 韩漫网免费在线阅读`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2 flex flex-col gap-1.5">
          {comic.isHot && (
            <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
              热门
            </span>
          )}
          {comic.isNew && (
            <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
              新番
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2 px-2 py-0.5 text-[10px] font-medium bg-background-900/70 text-background-100 rounded-md whitespace-nowrap">
          {comic.status}
        </div>
        <div className="absolute bottom-2 right-2 flex items-center gap-1 text-background-50 text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <i className="ri-eye-line"></i>
          <span>{comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 truncate font-heading group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-foreground-300">·</span>
          <span className="text-xs text-foreground-500">{comic.category}</span>
        </div>
        <div className="flex items-center gap-1 mt-2">
          <div className="flex items-center gap-0.5">
            <i className="ri-star-fill text-amber-400 text-xs"></i>
            <span className="text-xs font-medium text-foreground-700">{comic.rating}</span>
          </div>
          <span className="text-xs text-foreground-400 ml-auto">
            更新至{comic.chapters.length}话
          </span>
        </div>
      </div>
    </Link>
  );
}